/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { QuestionnaireApplicableRulesDto } from '../models/questionnaire-applicable-rules-dto';
import { questionnaireCheckActiveQuestionnaire$Json } from '../fn/questionnaire/questionnaire-check-active-questionnaire-json';
import { QuestionnaireCheckActiveQuestionnaire$Json$Params } from '../fn/questionnaire/questionnaire-check-active-questionnaire-json';
import { questionnaireCheckActiveQuestionnaire$Plain } from '../fn/questionnaire/questionnaire-check-active-questionnaire-plain';
import { QuestionnaireCheckActiveQuestionnaire$Plain$Params } from '../fn/questionnaire/questionnaire-check-active-questionnaire-plain';
import { QuestionnaireDto } from '../models/questionnaire-dto';
import { questionnaireGetQuestionnaireToPlay$Json } from '../fn/questionnaire/questionnaire-get-questionnaire-to-play-json';
import { QuestionnaireGetQuestionnaireToPlay$Json$Params } from '../fn/questionnaire/questionnaire-get-questionnaire-to-play-json';
import { questionnaireGetQuestionnaireToPlay$Plain } from '../fn/questionnaire/questionnaire-get-questionnaire-to-play-plain';
import { QuestionnaireGetQuestionnaireToPlay$Plain$Params } from '../fn/questionnaire/questionnaire-get-questionnaire-to-play-plain';
import { questionnaireValidateAnswer$Json } from '../fn/questionnaire/questionnaire-validate-answer-json';
import { QuestionnaireValidateAnswer$Json$Params } from '../fn/questionnaire/questionnaire-validate-answer-json';
import { questionnaireValidateAnswer$Plain } from '../fn/questionnaire/questionnaire-validate-answer-plain';
import { QuestionnaireValidateAnswer$Plain$Params } from '../fn/questionnaire/questionnaire-validate-answer-plain';
import { ValidationDto } from '../models/validation-dto';

@Injectable({ providedIn: 'root' })
export class QuestionnaireService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `questionnaireGetQuestionnaireToPlay()` */
  static readonly QuestionnaireGetQuestionnaireToPlayPath = '/v1/Questionnaire/GetQuestionnaireToPlay';

  /**
   * Get questionnaire to play by searching questionnaire and answers,   Permissions [GET_QUESTIONNAIRE] ,   Restricted to [KIOSK_HOME|INSURER].
   *
   * It will return the questionnaire to play
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `questionnaireGetQuestionnaireToPlay$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  questionnaireGetQuestionnaireToPlay$Plain$Response(params?: QuestionnaireGetQuestionnaireToPlay$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<QuestionnaireDto>> {
    return questionnaireGetQuestionnaireToPlay$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Get questionnaire to play by searching questionnaire and answers,   Permissions [GET_QUESTIONNAIRE] ,   Restricted to [KIOSK_HOME|INSURER].
   *
   * It will return the questionnaire to play
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `questionnaireGetQuestionnaireToPlay$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  questionnaireGetQuestionnaireToPlay$Plain(params?: QuestionnaireGetQuestionnaireToPlay$Plain$Params, context?: HttpContext): Observable<QuestionnaireDto> {
    return this.questionnaireGetQuestionnaireToPlay$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<QuestionnaireDto>): QuestionnaireDto => r.body)
    );
  }

  /**
   * Get questionnaire to play by searching questionnaire and answers,   Permissions [GET_QUESTIONNAIRE] ,   Restricted to [KIOSK_HOME|INSURER].
   *
   * It will return the questionnaire to play
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `questionnaireGetQuestionnaireToPlay$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  questionnaireGetQuestionnaireToPlay$Json$Response(params?: QuestionnaireGetQuestionnaireToPlay$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<QuestionnaireDto>> {
    return questionnaireGetQuestionnaireToPlay$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Get questionnaire to play by searching questionnaire and answers,   Permissions [GET_QUESTIONNAIRE] ,   Restricted to [KIOSK_HOME|INSURER].
   *
   * It will return the questionnaire to play
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `questionnaireGetQuestionnaireToPlay$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  questionnaireGetQuestionnaireToPlay$Json(params?: QuestionnaireGetQuestionnaireToPlay$Json$Params, context?: HttpContext): Observable<QuestionnaireDto> {
    return this.questionnaireGetQuestionnaireToPlay$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<QuestionnaireDto>): QuestionnaireDto => r.body)
    );
  }

  /** Path part for operation `questionnaireValidateAnswer()` */
  static readonly QuestionnaireValidateAnswerPath = '/v1/Questionnaire/ValidateAnswer';

  /**
   * Validate answer for rule,   Permissions [AuthenticatedUser] ,   Restricted to [KIOSK_HOME].
   *
   * It will return the questionnaire applicable rules
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `questionnaireValidateAnswer$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  questionnaireValidateAnswer$Plain$Response(params?: QuestionnaireValidateAnswer$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<QuestionnaireApplicableRulesDto>> {
    return questionnaireValidateAnswer$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Validate answer for rule,   Permissions [AuthenticatedUser] ,   Restricted to [KIOSK_HOME].
   *
   * It will return the questionnaire applicable rules
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `questionnaireValidateAnswer$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  questionnaireValidateAnswer$Plain(params?: QuestionnaireValidateAnswer$Plain$Params, context?: HttpContext): Observable<QuestionnaireApplicableRulesDto> {
    return this.questionnaireValidateAnswer$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<QuestionnaireApplicableRulesDto>): QuestionnaireApplicableRulesDto => r.body)
    );
  }

  /**
   * Validate answer for rule,   Permissions [AuthenticatedUser] ,   Restricted to [KIOSK_HOME].
   *
   * It will return the questionnaire applicable rules
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `questionnaireValidateAnswer$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  questionnaireValidateAnswer$Json$Response(params?: QuestionnaireValidateAnswer$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<QuestionnaireApplicableRulesDto>> {
    return questionnaireValidateAnswer$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Validate answer for rule,   Permissions [AuthenticatedUser] ,   Restricted to [KIOSK_HOME].
   *
   * It will return the questionnaire applicable rules
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `questionnaireValidateAnswer$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  questionnaireValidateAnswer$Json(params?: QuestionnaireValidateAnswer$Json$Params, context?: HttpContext): Observable<QuestionnaireApplicableRulesDto> {
    return this.questionnaireValidateAnswer$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<QuestionnaireApplicableRulesDto>): QuestionnaireApplicableRulesDto => r.body)
    );
  }

  /** Path part for operation `questionnaireCheckActiveQuestionnaire()` */
  static readonly QuestionnaireCheckActiveQuestionnairePath = '/v1/Questionnaire/CheckActiveQuestionnaire';

  /**
   * Check if current connected patient has valid questionnaire,   Permissions [AuthenticatedUser] ,   Restricted to [KIOSK_HOME].
   *
   * It will return an object containing if insurer has valid questionnaire or not and the reason why
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `questionnaireCheckActiveQuestionnaire$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  questionnaireCheckActiveQuestionnaire$Plain$Response(params?: QuestionnaireCheckActiveQuestionnaire$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ValidationDto>> {
    return questionnaireCheckActiveQuestionnaire$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Check if current connected patient has valid questionnaire,   Permissions [AuthenticatedUser] ,   Restricted to [KIOSK_HOME].
   *
   * It will return an object containing if insurer has valid questionnaire or not and the reason why
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `questionnaireCheckActiveQuestionnaire$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  questionnaireCheckActiveQuestionnaire$Plain(params?: QuestionnaireCheckActiveQuestionnaire$Plain$Params, context?: HttpContext): Observable<ValidationDto> {
    return this.questionnaireCheckActiveQuestionnaire$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ValidationDto>): ValidationDto => r.body)
    );
  }

  /**
   * Check if current connected patient has valid questionnaire,   Permissions [AuthenticatedUser] ,   Restricted to [KIOSK_HOME].
   *
   * It will return an object containing if insurer has valid questionnaire or not and the reason why
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `questionnaireCheckActiveQuestionnaire$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  questionnaireCheckActiveQuestionnaire$Json$Response(params?: QuestionnaireCheckActiveQuestionnaire$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ValidationDto>> {
    return questionnaireCheckActiveQuestionnaire$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Check if current connected patient has valid questionnaire,   Permissions [AuthenticatedUser] ,   Restricted to [KIOSK_HOME].
   *
   * It will return an object containing if insurer has valid questionnaire or not and the reason why
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `questionnaireCheckActiveQuestionnaire$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  questionnaireCheckActiveQuestionnaire$Json(params?: QuestionnaireCheckActiveQuestionnaire$Json$Params, context?: HttpContext): Observable<ValidationDto> {
    return this.questionnaireCheckActiveQuestionnaire$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ValidationDto>): ValidationDto => r.body)
    );
  }

}
